import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { buildV3Location } from '../locationUtils'

export default function OnEnterRedirect({ onEnter }) {
  const location = useLocation()
  const params = useParams()
  const v3Location = buildV3Location(location, params)
  let redirectTo = null

  onEnter(v3Location, replacePath => {
    redirectTo = replacePath
  })

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />
  }
  return null
}
